import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';

// Async thunk for forgot password
export const getAllPoOrderThunk = createAsyncThunk(
    'getAllPoOrderThunk',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.getPoOrder(data);
             return response.data            
        } catch (error) {
           console.log(error);
           
        }
    }
);

// Async thunk for forgot password
export const getCartOrdersThunk = createAsyncThunk(
    'getCartOrders',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.getCartOrder(data);
             return response.data            
        } catch (error) {
          console.log(error);
          
        }
    }
);

export const getCartOrderdetailsThunk = createAsyncThunk(
    'getCartOrderdetails',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.getCartOrderDetails(data);
             return response.data.data            
        } catch (error) {
          console.log(error);
          
        }
    }
);

export const getPoOrderdetailsThunk = createAsyncThunk(
    'getPoOrderdetailsThunk',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.getPoOrderDetails(data);
             return response.data.data            
        } catch (error) {
          console.log(error);
          
        }
    }
);

const poOrdersSlice = createSlice({
    name: 'poorder',
    initialState: {
        loading: false,
        success: false,
        error: null,
        orders:[],
        page:1,
        orderDetails:{},
        activeTab:'Cart order'
    },
  reducers:{      
     setPoOrderPage:(state,action)=>{
        state.page = action.payload
     },
     setPoorderTab:(state,action)=>{
        state.activeTab = action.payload
     }
  },
    extraReducers: (builder) => {
        builder
            .addCase(getAllPoOrderThunk.pending, (state) => {
                state.loading = true;
               
            })
            .addCase(getAllPoOrderThunk.fulfilled, (state, action) => {
                state.loading = false;
               state.orders = action.payload
            })
            .addCase(getAllPoOrderThunk.rejected, (state, action) => {
                state.loading = false;
             
            })

            .addCase(getCartOrdersThunk.pending, (state) => {
                state.loading = true;
               
            })
            .addCase(getCartOrdersThunk.fulfilled, (state, action) => {
                state.loading = false;
               state.orders = action.payload
            })
            .addCase(getCartOrdersThunk.rejected, (state, action) => {
                state.loading = false;
             
            })

            .addCase(getCartOrderdetailsThunk.pending, (state) => {
                state.loading = true;
               
            })
            .addCase(getCartOrderdetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
               state.orderDetails = action.payload
            })
            .addCase(getCartOrderdetailsThunk.rejected, (state, action) => {
                state.loading = false;
             
            })

            .addCase(getPoOrderdetailsThunk.pending, (state) => {
                state.loading = true;
               
            })
            .addCase(getPoOrderdetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
               state.orderDetails = action.payload
            })
            .addCase(getPoOrderdetailsThunk.rejected, (state, action) => {
                state.loading = false;
             
            });
    }
});

export const {setPoOrderPage,setPoorderTab} = poOrdersSlice.actions
export default poOrdersSlice.reducer;
